import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const StartupPricingPage = () => {
return (
<div className="container py-5">
<h1 className="text-center mb-4 fw-bold">E-Commerce Web Application Pricing</h1>
<p className="text-center text-muted mb-5">
Professional-grade development tailored for startups — pay upfront or monthly with 0% APR.
</p>

<div className="row g-4">
{/* One-time payment */}
    <div className="col-md-4">
    <div className="card shadow-sm h-100">
    <div className="card-body">
    <h4 className="card-title fw-bold">💰 One-Time Payment</h4>
    <h2 className="text-success fw-bold mt-3">£3,500</h2>
    <p className="text-muted">Full ownership from day one</p>
    <ul className="list-group list-group-flush mt-4 mb-4">
    <li className="list-group-item">Custom-branded design</li>
    <li className="list-group-item">Payment gateway integration</li>
    <li className="list-group-item">Admin dashboard + order management</li>
    <li className="list-group-item">1-year free support</li>
    <li className="list-group-item">Mobile responsive & SEO-ready</li>
    </ul>
    <button className="btn btn-success w-100 mt-auto">Pay Now</button>
    </div>
    </div>
    </div>

{/* Monthly payment */}
    <div className="col-md-4">
        <div className="card shadow-sm h-100 border-primary">
            <div className="card-body">
            <h4 className="card-title fw-bold text-primary">📆 6-Month Payment Plan</h4>
            <h2 className="text-primary fw-bold mt-3">£583.33/mo</h2>
            <p className="text-muted">0% interest – total still just £3,500</p>
            <ul className="list-group list-group-flush mt-4 mb-4">
                <li className="list-group-item">Everything in one-time plan</li>
                <li className="list-group-item">No upfront development cost</li>
                <li className="list-group-item">Optional early repayment</li>
                <li className="list-group-item">Late fee policy applies</li>
                <li className="list-group-item">6-month full ownership</li>
            </ul>
            <button className="btn btn-primary w-100 mt-auto">Start Monthly Plan</button>
            </div>
            </div>
    </div>
     <div className="col-md-4">
        <div className="card shadow-sm h-100 border-primary">
            <div className="card-body">
            <h4 className="card-title fw-bold text-primary">📆 12-Month Payment Plan</h4>
            <h2 className="text-primary fw-bold mt-3">£291.67/mo</h2>
            <p className="text-muted">0% interest – total still just £3,500</p>
            <ul className="list-group list-group-flush mt-4 mb-4">
                <li className="list-group-item">Everything in one-time plan</li>
                <li className="list-group-item">No upfront development cost</li>
                <li className="list-group-item">Optional early repayment</li>
                <li className="list-group-item">Late fee policy applies</li>
                <li className="list-group-item">12-month full ownership</li>
            </ul>
            <button className="btn btn-primary w-100 mt-auto">Start Monthly Plan</button>
            </div>
            </div>
    </div>
</div>





{/* Optional Terms */}
<div className="mt-5">
<h4 className="fw-bold">📌 Additional Terms</h4>
<ul>
<li>Initial deposit optional (recommended: £300–£500)</li>
<li>Late payments may incur a £20 fee</li>
<li>Includes basic SEO & mobile optimization</li>
<li>Ongoing maintenance available after 1st year</li>
</ul>
</div>

{/* Call to Action */}
<div className="text-center mt-5">
<h5 className="fw-bold mb-3">Need a custom quote or want a proposal PDF?</h5>
<button className="btn btn-outline-dark">Contact Us</button>
</div>
</div>
);
};

export default StartupPricingPage;